<template>
    <!-- eslint-disable -->

        <div class="flex-grow">
            <div class="bg-theme-light">
                <div class="section container px-6 py-16 mx-auto">
                    <div class="items-center lg:flex">
                        <div class="w-full flex flex-col jusctify-center text-center">
                            
                            <h1 class="text-5xl text-theme-blue font-semibold">{{title}}</h1>
                            <h4 class="text-gray-900 text-xl w-11/12 md:w-9/12 m-auto text-center font-normal py-6">{{subtitle}}</h4>
                        </div>
                    </div>
                </div>
            </div> 

            <div class="section container mx-auto py-20">
               
                <div v-show="!posts" class="flex justify-center items-center"> 
                    <div class="animate-spin rounded-full h-16 w-16 border-t-2 border-b-2 border-theme-sky"></div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-12 gap">
                    <div class="col-span-3 pl-8">
                        <div v-for="category in categories" :key="category.id">
                            <h3 @click="filterPost(category)" class="text-xl text-theme-blue font-bold mt-4 hover:underline">{{ category.name }}</h3>
                            <ul class="ml-3 text-gray-600 text-lg">
                                <li v-for="child in category.children" :key="child.id" 
                                    @click="filterPost(child)"    
                                    class="mt-1 hover:underline hover:cursor">{{ child.name }}</li>
                            </ul>
                        </div>
                    </div>

                    <div class="col-span-8">
                        <div><h3 class="text-2xl text-theme-blue font-semibold mb-4">{{  }}</h3></div>
                        <div v-if="this.cat_selected != 'all'" class="w-full" @click="clearFilter">
                            <button class="ml-auto mb-4 flex items-center justify-center rounded-lg border border-theme-sky text-theme-sky py-1 px-2 text-sm
                            hover:bg-theme-sky hover:text-white" @click="filterPost('all')"><span class="tracking-wider">VER TODO</span></button>
                        </div>
                    
                        <div class="bg-gray-50 rounded-xl px-6 py-6 mb-12 grid grid-cols-7 shadow w-11/12 mx-auto md:w-full"  v-for="post in posts"> 
                            
                            <div class="col-span-7 flex flex-col gap-6 md:gap-0 md:flex-row ">   
                                <div class="w-3/3 md:w-1/3 rounded-md foto" :style="{'backgroundImage': buildImageUrl(post)}"  >
                                    <!-- <div class="w-full h-60 md:w-60 md:h-60 rounded-md foto" :style="{'backgroundImage': buildImageUrl(post)}" > </div> -->
                                </div> 

                                <div class="ml-5 w-3/3 md:w-2/3" >
                                        <h3 class="text-3xl text-theme-blue font-semibold mb-1 flex flex-col">
                                            <span class="uppercase bg-theme-light2 text-xs text-theme-sky py-2 px-2 rounded-xl w-2/3 md:w-1/3 text-center mb-3 ">
                                                {{ post['category']['name']}}</span>
                                            <router-link class="hover:underline" :to="{name:'NewsDetail', params: {slug:post['slug']}}"> {{ post['title'] }} </router-link>
                                        </h3>
                                        <div class="text-gray-700 text-xl mt-2">
                                            <div class="flex gap-1 items-center">
                                                <MapPinIcon class="w-6 h-6 mr-2 text-theme-sky"/>
                                                <a v-if="post['library']['location']" class="hover:underline mt-1" target="_blank" :href="post['library']['location']">
                                                {{post['library']['name']}} </a>
                                                <span v-else class="mt-1">{{post['library']['name']}}</span>
                                            </div> 
                                            
                                            <div v-if="post['date_evento']" class="mt-1 flex gap-1 items-center"> 
                                                <CalendarDaysIcon class="w-6 h-6 mr-2 text-theme-sky"/> {{ post['date_evento'] }} </div>
                                        </div>   
                                        <p class="text-gray-700 mt-4 mb-8 font-ptserif text-base" v-html="post['resumen']"></p>
                                        <router-link class="uppercase bg-theme-sky text-white rounded-lg text-center text-sm w-32 py-2 px-4 hover:bg-theme-blue"
                                                     :to="{name:'NewsDetail', params: {slug:post['slug']}}">Leer Más</router-link>

                                </div>
                            
                            </div> 

                        </div>

                    </div>
                </div>
            </div> 
    
        </div>   
    </template>
    
    
    <script>
       
    import { MapPinIcon, CalendarDaysIcon } from '@heroicons/vue/20/solid'
    import { inject } from 'vue';

    function  findCategoryBySlug(categories, slug) {
        for (const category of categories) {
            if (category.slug === slug) {
                return category;
            }

            if (category.children && category.children.length > 0) {
                const childResult = findCategoryBySlug(category.children, slug);
                if (childResult) {
                    return childResult;
                }
            }
        
            return null;
        }
    }

    export default {
        name: "News",
        components: {
            MapPinIcon,
            CalendarDaysIcon
        },

        setup(){
            const tituloNovedades = inject('tituloNovedades', 'Novedades');

            const img_pluma = require('@/assets/images/pluma.jpg')
            return{
                img_pluma,
                tituloNovedades,
            }
        },
        data(){     
            return{
                posts_full: "",
                posts : "",
                title: this.tituloNovedades,
                subtitle:"",
                content1:"",
                content2:"",
                cat_selected:"all",
                categories: [],
                filter: '',
                cat: [],
            }
        },
    
        methods: {
            filterPost(filter){
                
                if(filter == 'all'){
                    this.posts = this.posts_full
                    this.title = this.tituloNovedades
                    this.subtitle = ''
                    this.content1 = ''
                    this.content2 = ''

                }else{
                    // this.posts = this.posts_full.filter(obj => obj.category.id == child.id)
                    console.log(filter)

                    // Si la categoría tiene hijos, filtra por todas las categorías hijas
                    if (filter.children && filter.children.length > 0) {
                        const childIds = [filter.id, ...filter.children.map((c) => c.id)];
                        this.posts = this.posts_full.filter((obj) => childIds.includes(obj.category.id));
                    } else {
                        // Si la categoría no tiene hijos, filtra solo por esa categoría
                        this.posts = this.posts_full.filter((obj) => obj.category.id === filter.id);
                    }

                    
                    this.title = filter.name
                    this.subtitle = filter.parent_name
                    this.content1 = ''
                    this.content2 = ''
                }
                this.cat_selected = filter
            },
            
            async getCategories(){
                // var filter = '' // `?view=${view}`
                var get = `${process.env.VUE_APP_URL_CULTURAPP}api/getCategorias`
                const response = await fetch(get,{method: 'GET'})
                let data = await response.json()
                
                this.categories = data.arbol
                this.cat = data.categorias
            },

            async getNews(){
                // var filter = '' // `?view=${view}`
                var get = `${process.env.VUE_APP_URL_CULTURAPP}api/novedades`
                const response = await fetch(get,{method: 'GET'})
                this.posts = await response.json()                
                this.posts_full = this.posts
            },
            buildImageUrl(post) {
                // console.log(post)
                
                let img_url = post.image 
                              ? `${process.env.VUE_APP_URL_CULTURAPP}storage/${post.image}`
                              : `${process.env.VUE_APP_URL_CULTURAPP}storage/${post.category.image}`
                              
                return `url('${img_url}')`;
            },


        },

        mounted () {
            window.scrollTo(0, 0)
            console.log('soy el mounted')
        }, 

        created(){
            console.log('soy el created')

            this.filter = this.$route.query.filter;

            window.scrollTo(0, 0)
            this.getCategories().then(() => {
                this.getNews().then(() => {
                    if (this.filter) {
                        // const initialFilter = findCategoryBySlug(this.categories, this.filter);
                        const initialFilter = this.cat.find((c) => c.slug === this.filter);
                        // console.log(this.categories)
                        console.log(this.categories, this.filter, initialFilter)

                        if (initialFilter) {
                            this.filterPost(initialFilter);
                            // Limpia el query de la URL
                            // this.$router.replace({ query: {} });
                        }
                    }
                });
            });
        }
    }



</script>
<style scoped>
.foto{
    background-size: cover;
    background-position: center center;
}

</style>